import { TextInput, TextLabel } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React from 'react';

const Content = () => {
  const formikContext = useFormikContext();
  const { values, handleChange, handleBlur, errors, touched, submitCount } = formikContext;

  const _errors = {
    comentario: (submitCount > 0 || touched?.comentario) && errors?.comentario,
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextLabel id="assunto" label="Assunto" value="Alteração do plano comercial" />
        </Grid>

        <Grid item xs={12}>
          <span>
            <b>Mensagem</b>
            <br />
          </span>
          <span>
            Tenho interesse em saber mais sobre os planos comerciais que possibilitam cadastro de mais empresas.
          </span>
        </Grid>

        <Grid item xs={12}>
          <TextInput
            id="comentario"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values?.comentario}
            error={_errors.comentario}
            touched={_errors.comentario}
            maxLength={500}
            fullWidth
            multiline
            rows={8}
            variant="outlined"
            label="Comentários"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Content;
